// Third Party
import * as $ from "jquery"

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

// Services
import userService from '@/app/services/main/user/user-service';



export default {
	name: "ModalSavedAddresses",
	mixins: [tableMixins, toastMessageMixins],
	data() {
		return {
			isAPILoading: false,
			isDeleting: false,
			isAPIDeleteLoading: false,
			showSelectAddressNote: false,
			showSelectDeleteNote: false,

			addressList: [],
			deleteAddressList: [],
			selectedAddress: null,
			addressType: "",
		}
	},
	created() {
	},
	mounted() {
        $(this.$refs.modalSavedAddresses).on('hidden.bs.modal', () => {
			this.deleteAddressList = [];
			this.isDeleting = false;
			this.showSelectAddressNote = false;
			this.showSelectDeleteNote = false;
		});
	},
	methods: {
		async openModal(addressType, defaultSelectedAddress) {
			this.addressType = addressType ? addressType[0].toUpperCase() + addressType.slice(1) : "";

			try{
				const response = await userService.getUserDefaultAddresses(addressType.toUpperCase());

				if(response.status === STATUS_CODES.SUCCESS){
					const addressListResponse = await response.data;
					this.addressList = addressListResponse;

					if(defaultSelectedAddress && defaultSelectedAddress.id){
						this.selectedAddress = addressListResponse.find(address => address.id === defaultSelectedAddress.id);
						
						// this.addressList = [...this.addressList].sort((a, b) => {
						// 	if(a.id === this.selectedAddress.id){
						// 		return -1
						// 	} 
						// 	return 1;
						// })
					} else {
						this.selectedAddress = null;
					}

				} else {
					this.showAPIErrorToast("Unable to fetch addresses.", response);
                }
            } catch (error) {
                this.showGenericErrorToast();
            }
			
			$(this.$refs.modalSavedAddresses).modal("show");
		},
		hideModal() {
			$(this.$refs.modalSavedAddresses).modal("hide");
		},
		closeModal(shouldCloseDirectly = true) {
			if (this.isNativeApp) {
				setTimeout(function () {
					window.ReactNativeWebView.postMessage("cart")
				}, 0)
			}

			if(shouldCloseDirectly){
				this.hideModal();
				this.showSelectAddressNote = false;
			}
			else if(this.isDeleting){
				this.deleteAddressList = [];
				this.isDeleting = false;
			} 

			this.showSelectDeleteNote = false;
		
		},
		async confirmAction(){
			if(!this.isDeleting){
				
				// show note "Please select an address." if no address is selected
				if(!this.selectedAddress) {
					this.showSelectAddressNote = true;
					this.showSelectDeleteNote = false;
					return;
				}

				// emit or pass value to parent
				this.$emit("onSelectFromSavedAddresses", this.selectedAddress);
			} else {

					// show note "Please select an address to delete." if no address is selected to delete
				if(!this.deleteAddressList.length){
					this.showSelectDeleteNote = true;
					this.showSelectAddressNote = false;
					return;
				}

				await this.deleteSavedAddresses();
			}

			this.closeModal();
			this.deleteAddressList = [];
			this.showSelectAddressNote = false;
			this.showSelectDeleteNote = false;
		},
		showDeleteAddress(){
			this.isDeleting = !this.isDeleting;
			this.showSelectAddressNote = false;

			if(!this.isDeleting){
				this.deleteAddressList = [];
			}
		},
		async deleteSavedAddresses(){
			if(!this.deleteAddressList.length){
				return;
			}
			
			try{
				this.isAPIDeleteLoading = true;
				const addressIds = this.deleteAddressList.map(address => address.id);

				const details = {
					addressIds,
					addressType: this.addressType
				};

				const response = await userService.deleteUserDefaultAddresses(details);

				if(response.status === STATUS_CODES.SUCCESS_NO_CONTENT){
					this.showCustomSuccessToast(null, `Successfully deleted the selected addresses.`);
				} else {
					this.showAPIErrorToast("Unable to delete selected addresses.", response);
                }

            } catch (error) {
                this.showGenericErrorToast();
            } finally{
				this.isAPIDeleteLoading = false;
				this.hideModal();
			}
		}
	},
}
